import { typography } from './tokens';

export function getTypographyOptions(headingColor: string, bodyColor: string, secondaryText: string) {
  return {
    fontFamily: typography.bodyFont,

    h1: {
      fontFamily: typography.headingFont,
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.2,
      letterSpacing: '-1px',
      color: headingColor,
      '@media (max-width:768px)': { fontSize: '2.25rem' },
    },
    h2: {
      fontFamily: typography.headingFont,
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.3,
      letterSpacing: '-0.5px',
      color: headingColor,
      '@media (max-width:768px)': { fontSize: '1.75rem' },
    },
    h3: {
      fontFamily: typography.headingFont,
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
      letterSpacing: '0px',
      color: bodyColor,
      '@media (max-width:768px)': { fontSize: '1.25rem' },
    },
    h4: {
      fontFamily: typography.headingFont,
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
      color: bodyColor,
    },
    h5: {
      fontFamily: typography.headingFont,
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.4,
      color: bodyColor,
    },
    h6: {
      fontFamily: typography.headingFont,
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4,
      color: bodyColor,
    },

    body1: {
      fontFamily: typography.bodyFont,
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.6,
      color: bodyColor,
    },
    body2: {
      fontFamily: typography.bodyFont,
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.25px',
      color: bodyColor,
    },

    button: {
      fontFamily: typography.bodyFont,
      fontWeight: 500,
      fontSize: '0.9375rem',
      lineHeight: 1.4,
      letterSpacing: '0.2px',
      textTransform: 'none' as const,
    },

    caption: {
      fontFamily: typography.bodyFont,
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.4,
      letterSpacing: '0.5px',
      color: secondaryText,
    },
  };
}
